<template>
  <CCard class="dataTable py-5 mt-3">
    <CRow class="pt-5 pb-4">
      <CCol class="d-flex flex-column">
        <div>
          <h2 class="titlePage font-weight-normal text-capitalize">
            {{ $t('sender.smsSender.smsSenderList.header1') }}
          </h2>
        </div>
      </CCol>
    </CRow>
    <CCardHeader
      v-if="totalRecords > 0 || tableFilterValue != null || filterSender"
      class="dataTable__header d-flex justify-content-between px-0 pb-5"
    >
      <div class="dataTable__countContants">
        <h3 class="font-weight-normal text-warning mt-3 d-flex align-items-sm-center">
          <CIcon name="pending" class="text-warning mx-2" size="custom-size" :height="30" viewBox="0 0 32 32" />
          {{ totalPendings || 0
          }}<span class="font-sm font-weight-normal text-uppercase ml-2">{{ $t('sender.smsSender.smsSenderList.pending-orders') }}</span>
        </h3>
      </div>
      <div class="dataTable__search">
        <CInput
          maxlength="50"
          type="search"
          :placeholder="$t('sender.smsSender.smsSenderList.placehoder-search')"
          addInputClasses="pl-5"
          class="iconSearchPlaceholder pb-0"
          v-model="tableFilterValue"
        >
        </CInput>
      </div>
      <div v-if="canCreateSender" class="dataTable__buttonLink">
        <router-link class="btn btn-primary px-4 py-3 font-weight-bold" tag="button" :to="{ name: 'new-senders-sms' }">{{
          $t('sender.smsSender.smsSenderList.button.newSender')
        }}</router-link>
      </div>

      <!-- <button @click="testeAcc">acc</button> -->
    </CCardHeader>
    <template v-if="totalRecords == 0 && tableFilterValue == null && filterSender == false">
      <EmptyList
        :loading="loadingGetList"
        :linkText="canCreateSender ? $t('sender.smsSender.smsSenderList.button.newSender') : null"
        :linkTo="{ name: 'new-senders-sms' }"
        :title="$t('sender.smsSender.smsSenderList.text.noSenders')"
        :subTitle="canCreateSender ? $t('sender.smsSender.smsSenderList.text.newSender') : null"
      />
    </template>
    <template v-if="totalRecords > 0 || tableFilterValue != null || filterSender">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
      <HeaderActions
        :show="{
          checkItems: true,
          approveRefuse: this.showApproveRefuse,
          associate: this.showAssociate,
          delete: this.showDelete,
          manage: false,
          filterBy: true,
        }"
        :showApproveRefuse="showApproveRefuse"
        :loadingSenderRequest="loadingSenderRequest"
        :multiSelect="false"
        :itemsListSelected="Boolean(itemsListSelected)"
        :filterByData="[
          { column: 'OrganizationStatusId', value: 1, label: $t('sender.smsSender.smsSenderList.filterBy.active') },
          { column: 'OrganizationStatusId', value: 2, label: $t('sender.smsSender.smsSenderList.filterBy.inactive') },
          { column: 'SenderStatusId', value: 1, label: $t('sender.smsSender.smsSenderList.filterBy.pending') },
          { column: 'SenderStatusId', value: 2, label: $t('sender.smsSender.smsSenderList.filterBy.approved') },
          { column: 'SenderStatusId', value: 3, label: $t('sender.smsSender.smsSenderList.filterBy.refused') },
        ]"
        :confirmationDeleteDescription="$t('sender.smsSender.delete.description')"
        @confirm="deleteItemsSelected"
        @filterBy="chooseFilterBy"
        @approveOrReprove="approveOrReprove"
      />

      <CCardBody class="dataTable__body p-0">
        <CDataTable
          :items="registers"
          :fields="headers"
          :table-filter="{ external: true, lazy: true }"
          :table-filter-value.sync="tableFilterValue"
          items-per-page-select
          @row-clicked="(item) => check(item)"
          :items-per-page.sync="itemsPerPage"
          @pagination-change="paginationChange"
          :active-page="1"
          hover
          :loading="loading"
        >
          <template #loading>
            <div class="d-flex justify-content-center align-items-center dataTable__loading">
              <CSpinner class="my-3" color="primary" />
            </div>
          </template>

          <template #select="{ item }">
            <td>
              <CInputRadio name="check" class="text-center checkboxTable" :checked="item._selected" custom />
            </td>
          </template>

          <template #showDetails="{ item, index }">
            <td class="text-center" @click="toggleDetails(item, index)">
              <span>
                <u class="text-uppercase"> {{ $t('sender.smsSender.smsSenderList.text-detail') }} </u>
                <CIcon name="arrow" class="mx-1" size="custom-size" :height="15" viewBox="0 0 32 32" />
              </span>
            </td>
          </template>

          <template #details="{ item }">
            <CCollapse :show="Boolean(item._toggled)" class="bg-gray-200 text-gray-600">
              <ul class="d-flex listItem__detail px-5 pt-4 mb-0">
                <li class="listItem__detailItem">
                  <div class="d-flex align-items-center">
                    <CIcon name="infoSquareFull" :height="18" class="mr-2" viewBox="0 0 32 32" />
                    {{ $t('sender.smsSender.smsSenderList.detail.ID') }}
                  </div>
                  {{ item.id }}
                </li>
                <li class="listItem__detailItem" v-if="isSendit">
                  <div class="d-flex align-items-center text-uppercase">
                    <CIcon name="fileFull" :height="18" class="mr-2" viewBox="0 0 32 32" />
                    {{ $t('sender.smsSender.smsSenderList.detail.validation-doc') }}
                  </div>
                  <span style="width: 90%; display: inline-block" @click="downloadDoc(item.file.fileName, item.file.originalFileName)">
                    {{ item.file.originalFileName }}
                    <CIcon name="arrowExport" class="" size="custom-size" :height="15" viewBox="0 0 32 32" />
                  </span>
                </li>
                <li class="listItem__detailItem">
                  <div class="d-flex align-items-center">
                    <span class="text-uppercase">
                      {{ $t('sender.smsSender.smsSenderList.detail.request-date') }}
                    </span>
                  </div>
                  {{ formatDate(item.requestDatetime) }}
                </li>
                <li class="listItem__detailItem">
                  <div class="d-flex align-items-center">
                    <span class="text-uppercase">
                      {{ $t('sender.smsSender.smsSenderList.detail.reply-date') }}
                    </span>
                  </div>
                  {{ formatDate(item.answerDatetime) }}
                </li>
                <li class="listItem__detailItem text-uppercase">
                  <div class="d-flex align-items-center">
                    <span class="text-uppercase">
                      {{ $t('sender.smsSender.smsSenderList.detail.order-status') }}
                    </span>
                  </div>
                  <CIcon
                    :name="statusOrder(item.statusId)"
                    :class="statusOrder(item.statusId)"
                    class="mx-2"
                    size="custom-size"
                    :height="19"
                    viewBox="0 0 32 32"
                  />
                  {{ $t(`sender.smsSender.smsSenderList.status-order.${statusOrder(item.statusId)}`) }}
                </li>
                <li class="listItem__detailItem big" v-show="item.statusId !== 2">
                  <div class="d-flex align-items-center">
                    <span class="text-uppercase">
                      {{ $t('sender.smsSender.smsSenderList.detail.the-reason') }}
                    </span>
                  </div>
                  {{ item.reasonText }}
                </li>
              </ul>
            </CCollapse>
          </template>

          <!-- eslint-disable-next-line -->
          <template #organizationSender.isActive="{ item }">
            <td>
              <span :class="statusOrganization(item.isActive)" class="text-capitalize">
                {{ $t(`sender.smsSender.smsSenderList.status.${statusOrganization(item.organizationSender.isActive)}`) }}
              </span>
            </td>
          </template>

          <template #answerOrganizationUserId="{ item }">
            <td>
              <span>
                {{ item.answerOrganizationUserId || '' }}
              </span>
            </td>
          </template>

          <template #statusId="{ item }">
            <td>
              <span class="text-uppercase d-flex align-items-center">
                <CIcon
                  :name="statusOrder(item.statusId)"
                  :class="statusOrder(item.statusId)"
                  class="mx-2"
                  size="custom-size"
                  :height="19"
                  viewBox="0 0 32 32"
                />
                <span>{{ $t(`sender.smsSender.smsSenderList.status-order.${statusOrder(item.statusId)}`) }}</span>
              </span>
            </td>
          </template>
        </CDataTable>
      </CCardBody>

      <CPagination
        v-show="pages > 0 && totalRecords > 0"
        align="center"
        :pages="pages"
        :active-page.sync="activePage"
        class="dataTable__newPagination mt-3"
      >
        <template slot="previous-button">
          <span class="newPagination__button p-2 btnPagination">
            {{ $t('audience.audienceList.text.prev') }}
          </span>
        </template>
        <template slot="next-button">
          <span class="newPagination__button p-2 btnPagination">
            {{ $t('audience.audienceList.text.next') }}
          </span>
        </template>
      </CPagination>
    </template>
  </CCard>
</template>

<script>
const headerLabel = [
  {
    key: 'select',
    label: '',
    _classes: 'hidde',
    _style: 'width:50px',
  },
  { key: 'sender', label: 'SENDER' },
  { key: 'requestingUserName', label: 'REQUESTED BY' },
  { key: 'organizationSender.isActive', label: 'STATUS' },
  { key: 'answerName', label: 'ANSWERED BY' },
  { key: 'statusId', label: 'ORDER STATUS' },
  {
    key: 'showDetails',
    label: '',
    _classes: 'hidde',
    _style: 'width:150px',
  },
]

import HeaderActions from '@/components/table/HeaderActions'
import MenssageAlert from '@/components/MenssageAlert'
import { dateTimeFormatString } from '../../../utils/dateUtil'
import fileDownload from 'js-file-download'
import EmptyList from '@/components/EmptyList'
import services from '@/services.js'
import { organizationType } from '@/utils/enumsUtils.js'
import { mapGetters } from 'vuex'

export default {
  name: 'AudienceTable',
  components: {
    MenssageAlert,
    HeaderActions,
    EmptyList,
  },
  data() {
    return {
      showApproveRefuse: false,
      loadingSenderRequest: false,
      loadingGetList: false,
      columnFilterValue: {},
      tableFilterValue: null,
      loadedItems: [],
      loading: false,
      itemsPerPage: 10,
      pages: 0,
      headers: [],
      totalPendings: 0,
      totalRecords: 0,
      itemsListSelected: null,
      activePage: 1,
      responsive: false,
      messages: [],
      SenderStatusId: null,
      OrganizationStatusId: null,
      collapseDuration: 0,
      details: [],
      pagination: [],
      organizationType: 0,
      isSendit: null,
    }
  },

  created() {
    this.isSendit = organizationType(this.$store.state.auth.session.organization.organizationType) == 'sendit'

    this.loadingGetList = true
    this.getData({
      page: this.activePage,
      count: this.itemsPerPage,
      Sender: this.tableFilterValue,
      SenderStatusId: this.SenderStatusId,
      OrganizationStatusId: this.OrganizationStatusId,
    })
  },

  mounted() {
    this.$root.$on('approveOrReprove', (obj) => {
      this.approveOrReprove(obj)
    })

    this.organizationId()
    this.setTypeSender()
    this.getInfoorganization()
  },

  watch: {
    reloadParams() {
      this.onTableChange()
    },
  },

  computed: {
    ...mapGetters({
      hasSessionPermission: 'auth/hasSessionPermission',
    }),

    filterSender() {
      return this.SenderStatusId != null || this.OrganizationStatusId != null
    },
    registers() {
      return this.loadedItems.map((sender) => {
        if (this.itemsListSelected == sender.id) {
          this.$store.dispatch('senders/setIdSender', sender.organizationSender.id)
        }

        return {
          ...sender,
          _selected: this.itemsListSelected == sender.id,
          _classes: [sender._classes, (sender._selected = this.itemsListSelected == sender.id ? 'table-selected' : '')],
        }
      })
    },

    itemsPending() {
      return 0
      // return this.loadedItems.find(item => item.statusIdto == 1)
    },

    // showApproveRefuse() {
    //   //só mostra a feature de aprovação se perfil for sendit
    //   if (!this.isSendit) {
    //     return false
    //   }

    //   // só mostra a featuea de aprovação se  status por pedding
    //   const item = this.loadedItems.find((item) => item.id == this.itemsListSelected) || null
    //   return item ? item.statusId == 1 : null // 1 == pedding
    // },

    showAssociate() {
      // só mostra a feature de associaçao se  status por approved
      const item = this.loadedItems.find((item) => item.id == this.itemsListSelected) || null
      // 2 == approved
      return item ? item.statusId == 2 : null && this.hasSessionPermission('Sender_AddUser') && this.hasSessionPermission('Sender_RemoveUser')
    },

    reloadParams() {
      return [this.activePage, this.itemsPerPage, this.tableFilterValue, this.SenderStatusId, this.OrganizationStatusId]
    },

    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage
      const totalPage = this.activePage * 10 > this.totalRecords ? this.totalRecords : this.activePage * 10
      return `${first} - ${totalPage}  ${this.$t('general.components.table.pagination.separate-numbers')} ${this.totalRecords}`
    },

    canCreateSender() {
      return this.hasSessionPermission('Sender_Create')
    },

    showDelete() {
      return this.hasSessionPermission('Sender_Delete')
    },
  },

  methods: {
    async getInfoorganization() {
      const response = await services.getOrganization(this.$store.state.auth.organizationId)
      if (!response.data.success) return

      this.organizationType = response.data.data.organizationType

      //1 SENDIT 2 CLIENT
    },
    formatDate(date) {
      return date ? dateTimeFormatString(date) : ''
    },

    headerHandle() {
      return [
        {
          key: 'select',
          label: '',
          _classes: 'hidde',
          _style: 'width:50px',
        },
        { key: 'sender', label: this.$t('general.table.header.sender') },
        { key: 'requestingUserName', label: this.$t('general.table.header.requestedBy') },
        { key: 'organizationSender.isActive', label: this.$t('general.table.header.domainStatus') },
        { key: 'answerName', label: this.$t('general.table.header.answeredBy') },
        { key: 'statusId', label: this.$t('general.table.header.orderStatus') },
        {
          key: 'showDetails',
          label: '',
          _classes: 'hidde',
          _style: 'width:150px',
        },
      ]
    },

    mountItemsTable(arr) {
      return arr.reduce((acc, cur, index) => {
        acc.push({
          ...cur,
          _toggled: false,
          index: index,
          _classes: [cur._selected ? 'table-selected' : null],
        })
        return acc
      }, [])
    },

    getData(data) {
      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .getSenders(organizationId, { params: data })
        .then((senders) => {
          // this.pages = senders.data.data.pagination.totalPages / ;
          this.pages = Math.ceil(senders.data.data.pagination.totalRecords / 10)
          this.totalPendings = senders.data.data.totalPending
          this.totalRecords = senders.data.data.pagination.totalRecords
          this.activePage = senders.data.data.pagination.currentPage
          this.headers = this.headerHandle()
          this.loadedItems = this.mountItemsTable(senders.data.data.senderRequests)
          this.pagination = senders.data.data.pagination
        })
        .catch(() => {
          this.loadedItems = []
        })
        .finally(() => {
          this.loading = false
          this.loadingGetList = false
        })
    },

    onTableChange() {
      this.loading = true
      this.getData({
        page: this.activePage,
        count: this.itemsPerPage,
        Sender: this.tableFilterValue,
        SenderStatusId: this.SenderStatusId,
        OrganizationStatusId: this.OrganizationStatusId,
      })
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    check(item) {
      this.$set(this.loadedItems[item.index], '_selected', !this.loadedItems[item.index]._selected)
      this.itemsListSelected = item.id

      // Condições de exibição para contas do tipo Sendit
      // 1 == pedding
      if (this.isSendit && item.statusId == 1) {
        this.showApproveRefuse = true
      } else {
        this.showApproveRefuse = false
      }

      this.$store.dispatch('senders/setIdSender', item.organizationSender.id)
    },

    isApprovedSender(id) {
      return this.loadedItems.filter((item) => item.id == id)[0].statusId == 2 //approved
    },

    deleteItemsSelected() {
      this.messages = []

      if (!this.isApprovedSender(this.itemsListSelected)) {
        this.messages.push({
          status: 'warning',
          text: this.$t('sender.smsSender.smsSenderList.response.approved'),
        })
        return
      }
      let organizationId = this.$store.state.auth.organizationId

      services
        .deleteSender(organizationId, this.itemsListSelected)
        .then(({ data }) => {
          this.onTableChange()

          this.messages.push({
            status: 'success',
            text: data.message ? data.message : this.$t('sender.smsSender.smsSenderList.response.been-deleted'),
          })

          setTimeout(() => {
            this.itemsListSelected = null
          }, 1000)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    statusOrder(position) {
      const positions = {
        1: 'pending',
        2: 'approved',
        3: 'refused',
      }

      return positions[position] || positions.default
    },

    statusOrganization(position, item) {
      return position ? 'active' : 'inactive'
    },

    chooseFilterBy(item) {
      this.SenderStatusId = null
      this.OrganizationStatusId = null

      if (item === 'all') {
        return
      }

      this[item.column] = item.value
    },

    toggleDetails(item, index) {
      this.$set(this.loadedItems[index], '_toggled', !item._toggled)
      this.collapseDuration = 300
      this.$nextTick(() => {
        this.collapseDuration = 0
      })
    },

    downloadDoc(fileName, originalFileName) {
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .getDownloadDocSender(organizationId, fileName)
        .then((response) => {
          fileDownload(response.data, originalFileName, response.headers['content-type'])

          this.messages.push({
            status: 'success',
            text: response.data.message || 'Success',
          })
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message || 'error',
          })
        })
    },

    approveOrReprove(obj) {
      this.messages = []
      try {
        let item = this.loadedItems.find((item) => item.id == this.itemsListSelected && item.statusId == 1)
        let organizationId = this.$route.params.organizationId
        this.loadingSenderRequest = true
        if (!item) {
          return
        }
        this.showApproveRefuse = false
        services
          .approveorreject(organizationId, {
            senderRequestId: item.id,
            sender: item.sender,
            status: obj.status,
            reasonText: obj.reasonText,
          })
          .then(() => {
            this.showApproveRefuse = false
            this.onTableChange()
          })
          .catch((error) => {
            this.messages.push({
              status: 'danger',
              text: error.response.data.message,
            })
          })
          .finally(() => (this.loadingSenderRequest = false))
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.message || '',
        })
      }
    },

    organizationId() {
      this.$store.dispatch('senders/organizationUsers', this.$store.state.auth.organizationId)
    },

    setTypeSender() {
      const nameRoute = this.$route.name.split('-')[1]
      const type = nameRoute.charAt(0).toUpperCase() + nameRoute.slice(1)
      this.$store.dispatch('senders/setTypeSender', type)
    },
  },
}
</script>
<style scoped lang="scss">
.pending {
  color: var(--warning);
}

.active,
.approved {
  color: var(--success);
}

.refused {
  color: var(--danger);
}

.listItem__download {
  cursor: pointer;
}

.listItem__name {
  flex: 0 0 20%;
  min-width: 250px;
}

.listItem__numbers {
  font-size: $font-size-xs;
  position: relative;
}

.listItem__detail {
  flex-wrap: wrap;
}

.listItem__detailItem {
  flex: 0 0 25%;
  margin-bottom: 2%;

  &.big {
    flex: 0 0 50%;
  }
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
